import { Injectable } from '@angular/core';
import { FactoryService } from './factory.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PlatformDetect } from '@core/libs/platform/platform-detect';
import { JSBridgeService } from './jsbridge.service';
import { bussinessCodeMap } from '@core/libs/config/profile-mapping';

declare const window: any;
@Injectable({
  providedIn: 'root'
})
export class ComRouteService {

  constructor(
    private router: Router,
    private actRoute: ActivatedRoute,
    private platform: PlatformDetect,
    private jsBridgeSer: JSBridgeService,
    private factorySer: FactoryService
  ) { }

  async route(path: string, openTab: boolean = false, param?: any) { 
    const lang = this.factorySer.language;
    console.log('route lang..',lang);
    if (this.factorySer.isWebStyle && openTab) {
      window.open(`${location.origin}/${lang}/shprofile/${path}`);
    } else { 
      if (!param) { 
        param = { queryParams: this.actRoute?.snapshot?.queryParams };
      }
      if (path === 'login') {
        this.toLogin(param);
      } else { 
        this.router.navigate([`${lang}/shprofile/${path}`], param);
      }
    }
  }

  /**
   * @param openWebView 是否新打开webview
   * @param toLogin 是否强制（不判断登录态）跳转到login
   */
  public checkToLogin(openWebView?: boolean,toLogin?: boolean) { 
    if (this.factorySer.notToLogin) return false; //notToLogin use for: don't to login when init member modules
    this.factorySer.setLoginStatus(false);
    // gpl下 h5登录态丢失跳回小程序
    if (this.factorySer.getBusiness() === bussinessCodeMap.GPL && this.factorySer.delta) {
      wx.miniProgram.navigateBack({ delta: this.factorySer.delta });
      return;
    } else { 
      this.toLogin({ queryParams: this.actRoute?.snapshot?.queryParams }, openWebView,toLogin);
    }
  }

  private toLogin(param: any, openWebView: Boolean = true, toLogin: boolean = true) { 
    console.log('toLogin...', `param:${param} openWebView:${openWebView} toLogin:${toLogin}`);
    const pathName = window.location.pathname;
    this.factorySer.clearLogInfo();
    this.factorySer.toLogin = toLogin;
    if (pathName.includes('/shprofile/login') && !pathName.includes('visitor-mode')) {
      return;
    } else { 
      if (this.platform.isApp() && openWebView) {
        const params = { businessCode: this.factorySer.getBusiness()};
        this.jsBridgeSer.callJSBridge('gotoLogin', params, () => { 
          location.reload();
        });
      } else {
        this.router.navigate([`${this.factorySer.language}/shprofile/login`], param);  
      }
    }
  }
 
}
